import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class CustomMatPaginatorIntlService extends MatPaginatorIntl {
  firstPageLabel = this.translateService.instant('First page');
  lastPageLabel = this.translateService.instant('Last page');
  nextPageLabel = this.translateService.instant('Next page');
  previousPageLabel = this.translateService.instant('Previous page');
  itemsPerPageLabel = this.translateService.instant('Items per page');

  constructor(private translateService: TranslateService) {
    super();
  }
}
